<quill-editor
    #quillEditor
    [(ngModel)]="value"
    [modules]="quillModules"
    [maxLength]="maxLength"
    (onEditorCreated)="setUpEditor($event)"
    (ngModelChange)="onChange($event)"
    (onSelectionChanged)="onSelectionChange($event)"
    [required]="required"
    class="w-100"
    [readOnly]="readOnly"
    [placeholder]="placeholder"
></quill-editor>
